module.exports = __webpack_public_path__ + "img/palabras3silabas.a971d40a.png";